import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'main',
    component: () => import('../views/main/Index.vue'),
    redirect: '/home',
    children: [
      {
        path: '/home',
        name: 'home',
        component: () => import('../views/home/Index.vue'),
        meta: {
          // keepAlive: true
        }
      },
    ]
  },
  {
    path: '/ProjectInfo',
    name: 'ProjectInfo',
    component: () => import('V/menu/project/ProjectInfo.vue'),
    meta: {
    }
  },
  {
    path: '/projectOverview',
    name: 'projectOverview',
    component: () => import('V/menu/project/projectOverview/projectOverview.vue'),
    meta: {
    }
  },
  {
    path: '/supportingFacilities',
    name: 'supportingFacilities',
    component: () => import('V/menu/project/supportingFacilities/supportingFacilities.vue'),
    meta: {
    }
  },
  {
    path: '/tenantCompany',
    name: 'tenantCompany',
    component: () => import('V/menu/project/tenantCompany/tenantCompany.vue'),
    meta: {
    }
  },
  {
    path: '/ReportMatter',
    name: 'ReportMatter',
    component: () => import('V/menu/matter/ReportMatter.vue'),
    meta: {
    }
  },
  {
    path: '/ReportRepair',
    name: 'ReportRepair',
    component: () => import('V/menu/repair/ReportRepair.vue'),
    meta: {
    }
  },
  {
    path: '/Order',
    name: 'Order',
    component: () => import('V/menu/order/Order.vue'),
    meta: {
    }
  },
  {
    path: '/matterOrder',
    name: 'matterOrder',
    component: () => import('V/menu/order/matterOrder/matterOrder.vue'),
    meta: {
    }
  },
  {
    path: '/repairOrder',
    name: 'repairOrder',
    component: () => import('V/menu/order/repairOrder/repairOrder.vue'),
    meta: {
    }
  },
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
    // 将 param 存入 store
    if (to.query.param) {
        store.commit('setMonitorponintnum', to.query.param);
    }
    // 仅 home 页面限制：URL 无 param 且 store 也无缓存时拦截
    if (to.name === 'home') {
        if (!to.query.param && !store.state.monitorpointnum) {
            document.body.innerHTML = '<div style="text-align:center;padding-top:40vh;color:#999;font-size:16px;">访问参数无效，请通过正确方式访问</div>';
            next(false);
            return;
        }
    }
    gotoPage(to, from, next)
})

const gotoPage = (to, from, next) => {
  // 回到页面顶部
  try {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  } catch (e) {
    document.body.scrollTop = 0;
  }
  // 路由参数缓存
  let params = to.params;
  if (params) {
    if (Object.keys(params).length) {
      store.commit('setPageParams', {
        path: to.path,
        params: params
      });
    } else if (store.state.paramsMap[to.path]) {
      params = store.state.paramsMap[to.path];
      for (let key in params) {
        to.params[key] = params[key];
      }
    }
  }
  next();
}

router.afterEach((to, from) => {
  // 当前菜单选中状态
  store.commit('main/setSelectedKeys', [to.name])
  // 顶部tab页
  if (to.path) {
    store.dispatch('main/addTab', to.name)
  }
  store.commit('main/setSelectedTab', to.name)
})

export default router